(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edd-cart"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.edd-cart__form').forEach(function (form) {
    form.querySelectorAll('[data-qty]').forEach(function (stepper) {
      var input = stepper.querySelector('[data-qty-input]');
      var down = stepper.querySelector('[data-qty-down]');
      var up = stepper.querySelector('[data-qty-up]');
      if (!input) return;

      function commit(next) {
        if (next < 0) next = 0;
        input.value = next;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }

      if (down) {
        down.addEventListener('click', function () {
          commit(parseInt(input.value, 10) - 1 || 0);
        });
      }
      if (up) {
        up.addEventListener('click', function () {
          commit((parseInt(input.value, 10) || 0) + 1);
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-edd-col-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.href;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-community-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.edd-community').forEach(function (root) {
      var track = root.querySelector('[data-edd-gallery-track]');
      if (!track) return;
      var prev = root.querySelector('[data-edd-gallery-prev]');
      var next = root.querySelector('[data-edd-gallery-next]');
      var step = 236;
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step, behavior: 'smooth' }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-cookie-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var banner = document.getElementById('edd-cookie-banner');
    if (!banner) return;
    if (!localStorage.getItem('edd-cookie-dismissed')) {
      banner.hidden = false;
    }
    banner.querySelectorAll('[data-edd-cookie-dismiss]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        localStorage.setItem('edd-cookie-dismissed', '1');
        banner.hidden = true;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-edd-header]');
    if (!header) return;
    var toggle = header.querySelector('[data-edd-menu-toggle]');
    var drawer = document.querySelector('[data-edd-drawer]');
    if (!toggle || !drawer) return;
    var closers = drawer.querySelectorAll('[data-edd-menu-close]');

    function open() {
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      window.setTimeout(function () { drawer.hidden = true; }, 320);
    }
    toggle.addEventListener('click', function () {
      if (drawer.hidden) { open(); } else { close(); }
    });
    closers.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) { close(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-main-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-edd-mp]').forEach(function (root) {
    /* ---- Gallery ---- */
    var gallery = root.querySelector('[data-edd-gallery]');
    if (gallery) {
      var slides = Array.from(gallery.querySelectorAll('.edd-mp__slide'));
      var thumbs = Array.from(gallery.querySelectorAll('.edd-mp__thumb'));
      function showSlide(i) {
        slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          showSlide(parseInt(t.getAttribute('data-index'), 10) || 0);
        });
      });
    }

    /* ---- Quantity ---- */
    var qty = root.querySelector('[data-edd-qty]');
    if (qty) {
      var qtyInput = qty.querySelector('.edd-mp__qty-input');
      var minus = qty.querySelector('[data-edd-qty-minus]');
      var plus = qty.querySelector('[data-edd-qty-plus]');
      function clamp() {
        var v = parseInt(qtyInput.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        qtyInput.value = v;
      }
      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v - 1);
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
      qtyInput.addEventListener('change', clamp);
    }

    /* ---- Variant selection ---- */
    var dataEl = root.querySelector('[data-edd-variants]');
    var idInput = root.querySelector('[data-edd-id]');
    if (!dataEl || !idInput) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var optionGroups = Array.from(root.querySelectorAll('[data-edd-option]'));
    var priceEl = root.querySelector('[data-edd-price]');
    var compareEl = root.querySelector('[data-edd-compare]');
    var saleEl = root.querySelector('[data-edd-sale]');
    var atc = root.querySelector('[data-edd-atc]');
    var atcLabel = atc ? atc.querySelector('span') : null;

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var input = group.querySelector('[data-edd-option-input]:checked') ||
                    group.querySelector('select[data-edd-option-input]');
        return input ? input.value : null;
      });
    }

    function matchVariant() {
      var chosen = selectedOptions();
      if (!chosen.length) return variants[0];
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      }) || null;
    }

    function update() {
      var v = matchVariant();
      if (!v) {
        if (atc) {
          atc.disabled = true;
          if (atcLabel) atcLabel.textContent = 'Unavailable';
        }
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price;
      if (compareEl) {
        if (v.compareRaw > v.priceRaw) {
          compareEl.innerHTML = v.compare;
          compareEl.hidden = false;
          if (saleEl) saleEl.hidden = false;
        } else {
          compareEl.hidden = true;
          if (saleEl) saleEl.hidden = true;
        }
      }
      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
      }
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('[data-edd-option-input]').forEach(function (input) {
        input.addEventListener('change', update);
      });
    });

    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-offer-select"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.edd-offer').forEach(function (root) {
    var tiers = root.querySelectorAll('.edd-offer__tier');
    var variantInput = root.querySelector('[data-offer-variant]');
    var priceEl = root.querySelector('[data-offer-price]');
    var compareEl = root.querySelector('[data-offer-compare]');
    var perdayEl = root.querySelector('[data-offer-perday]');
    function select(label) {
      tiers.forEach(function (t) { t.classList.remove('is-selected'); });
      label.classList.add('is-selected');
      var radio = label.querySelector('[data-offer-tier]');
      if (radio && variantInput && radio.value) {
        variantInput.value = radio.value;
      }
      if (priceEl && label.dataset.price) { priceEl.textContent = label.dataset.price; }
      if (compareEl) { compareEl.textContent = label.dataset.compare || ''; }
      if (perdayEl) { perdayEl.textContent = label.dataset.perday || ''; }
    }
    tiers.forEach(function (label) {
      var radio = label.querySelector('[data-offer-tier]');
      if (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) select(label);
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.edd-carousel').forEach(function (section) {
    var track = section.querySelector('[data-edd-carousel-track]');
    var prev = section.querySelector('[data-edd-carousel-prev]');
    var next = section.querySelector('[data-edd-carousel-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('.edd-carousel__card');
      var width = card ? card.offsetWidth : 240;
      return width + 16;
    }
    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    var tabs = section.querySelectorAll('.edd-carousel__tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-product-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-edd-gallery]').forEach(function (gallery) {
    var slides = Array.from(gallery.querySelectorAll('.edd-hero__slide'));
    var thumbsWrap = gallery.querySelector('[data-edd-thumbs]');
    if (!slides.length || !thumbsWrap) return;
    var active = 0;

    slides.forEach(function (slide, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'edd-hero__thumb' + (i === 0 ? ' is-active' : '');
      var img = document.createElement('img');
      img.src = slide.src;
      img.alt = '';
      img.loading = 'lazy';
      btn.appendChild(img);
      btn.addEventListener('click', function () {
        setActive(i);
      });
      thumbsWrap.appendChild(btn);
    });

    var thumbs = Array.from(thumbsWrap.children);

    function setActive(i) {
      active = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) {
        s.classList.toggle('is-active', j === active);
      });
      thumbs.forEach(function (t, j) {
        t.classList.toggle('is-active', j === active);
      });
    }

    var prev = gallery.querySelector('[data-edd-prev]');
    var next = gallery.querySelector('[data-edd-next]');
    if (prev) prev.addEventListener('click', function () { setActive(active - 1); });
    if (next) next.addEventListener('click', function () { setActive(active + 1); });
  });

  document.querySelectorAll('.edd-hero').forEach(function (hero) {
    var tiers = hero.querySelectorAll('.edd-hero__tier');
    if (!tiers.length) return;
    var variantInput = hero.querySelector('[data-hero-variant]');
    var priceEl = hero.querySelector('[data-hero-price]');
    var compareEl = hero.querySelector('[data-hero-compare]');
    var perdayEl = hero.querySelector('[data-hero-perday]');
    function select(label) {
      tiers.forEach(function (t) { t.classList.remove('is-selected'); });
      label.classList.add('is-selected');
      var radio = label.querySelector('[data-hero-tier]');
      if (radio && variantInput && radio.value) { variantInput.value = radio.value; }
      if (priceEl && label.dataset.price) { priceEl.textContent = label.dataset.price; }
      if (compareEl) { compareEl.textContent = label.dataset.compare || ''; }
      if (perdayEl) { perdayEl.textContent = label.dataset.perday || ''; }
    }
    tiers.forEach(function (label) {
      var radio = label.querySelector('[data-hero-tier]');
      if (radio) {
        radio.addEventListener('change', function () { if (radio.checked) select(label); });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-product-redefined"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.edd-redefined').forEach(function (root) {
    var modal = root.querySelector('[data-edd-label-modal]');
    var openBtn = root.querySelector('[data-edd-label-open]');
    var closeBtn = root.querySelector('[data-edd-label-close]');
    if (!modal || !openBtn) { return; }
    openBtn.addEventListener('click', function () {
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
    });
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { modal.close(); });
    }
    modal.addEventListener('click', function (e) {
      if (e.target === modal) { modal.close(); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-video-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.edd-vr').forEach(function (root) {
    var track = root.querySelector('[data-edd-vr-track]');
    if (!track) return;
    var prev = root.querySelector('[data-edd-vr-prev]');
    var next = root.querySelector('[data-edd-vr-next]');

    function step() {
      var card = track.querySelector('.edd-vr__card');
      var width = card ? card.offsetWidth : 260;
      return width + 16;
    }
    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    root.querySelectorAll('[data-edd-vr-card]').forEach(function (card) {
      var btn = card.querySelector('[data-edd-vr-play]');
      var wrap = card.querySelector('[data-edd-vr-video]');
      var video = wrap ? wrap.querySelector('video') : null;
      var frame = card.querySelector('.edd-vr__frame');
      var featured = card.hasAttribute('data-edd-vr-featured');

      function activate() {
        if (!wrap || card.classList.contains('is-playing')) return;
        wrap.hidden = false;
        card.classList.add('is-playing');
        if (video) {
          if (featured) {
            video.loop = false;
            video.muted = false;
            video.controls = true;
            try { video.currentTime = 0; } catch (e) {}
          }
          var playing = video.play();
          if (playing && typeof playing.catch === 'function') {
            playing.catch(function () {});
          }
        }
      }

      if (btn) { btn.addEventListener('click', activate); }
      if (featured && frame) {
        frame.addEventListener('click', function (e) {
          if (e.target === video && card.classList.contains('is-playing')) return;
          activate();
        });
      }
    });

    var featuredCard = track.querySelector('.edd-vr__card--featured');
    if (featuredCard) {
      requestAnimationFrame(function () {
        var tr = track.getBoundingClientRect();
        var fr = featuredCard.getBoundingClientRect();
        var delta = (fr.left - tr.left) - (track.clientWidth - fr.width) / 2;
        if (delta > 0) { track.scrollLeft = delta; }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edd-vsl"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-edd-vsl]').forEach(function (root) {
    var frame = root.querySelector('[data-edd-vsl-frame]');
    var video = root.querySelector('[data-edd-vsl-video]');
    var play = root.querySelector('[data-edd-vsl-play]');
    if (!frame || !video) return;

    function activate() {
      if (frame.classList.contains('is-playing')) return;
      frame.classList.add('is-playing');
      video.loop = false;
      video.muted = false;
      video.controls = true;
      try { video.currentTime = 0; } catch (e) {}
      var p = video.play();
      if (p && p.catch) { p.catch(function () {}); }
    }

    if (play) { play.addEventListener('click', activate); }
    frame.addEventListener('click', function (e) {
      if (e.target === video && frame.classList.contains('is-playing')) return;
      activate();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gen-clinician-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gen-cl]').forEach(function (root) {
      var items = root.querySelectorAll('[data-cl-reveal]');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!('IntersectionObserver' in window) || reduce) {
        items.forEach(function (s) { s.classList.add('is-in'); });
        if (reduce) root.classList.add('js-reveal');
        return;
      }
      root.classList.add('js-reveal');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (s) { io.observe(s); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gen-effects-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gen-effects]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-et-tab]');
      var panels = root.querySelectorAll('[data-et-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.dataset.etPanel === tab.dataset.etTab);
          });
        });
      });
      root.querySelectorAll('.gen-et__faq-item').forEach(function (item) {
        var head = item.querySelector('.gen-et__faq-head');
        var body = item.querySelector('.gen-et__faq-body');
        head.addEventListener('click', function () {
          var open = body.hasAttribute('hidden');
          if (open) {
            body.removeAttribute('hidden');
          } else {
            body.setAttribute('hidden', '');
          }
          item.classList.toggle('is-open', open);
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gen-faq-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gen-faq] .gen-faq__item').forEach(function (item) {
      var head = item.querySelector('.gen-faq__head');
      head.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gen-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-gen-header]');
    if (!header) return;
    var lastY = 0;
    window.addEventListener(
      'scroll',
      function () {
        var y = window.scrollY;
        if (y > lastY && y > 120) {
          header.classList.add('is-hidden');
        } else {
          header.classList.remove('is-hidden');
        }
        lastY = y;
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gen-problem-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.gen-problem').forEach(function (root) {
      var openBtn = root.querySelector('[data-gen-label-open]');
      var modal = root.querySelector('[data-gen-label-modal]');
      if (!openBtn || !modal) return;
      var closeBtn = modal.querySelector('[data-gen-label-close]');
      function open() {
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      function close() {
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
      openBtn.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gen-product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gen-pm]').forEach(function (root) {
      /* ---- Gallery ---- */
      var slides = root.querySelectorAll('.gen-pm__slide');
      var thumbs = root.querySelectorAll('.gen-pm__thumb');
      var thumbsWrap = root.querySelector('[data-gen-thumbs]');
      function setActive(index) {
        slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.index === String(index)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.index === String(index)); });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { setActive(t.dataset.index); });
      });
      var prev = root.querySelector('[data-gen-thumbs-prev]');
      var next = root.querySelector('[data-gen-thumbs-next]');
      if (prev && thumbsWrap) prev.addEventListener('click', function () { thumbsWrap.scrollBy({ left: -98, behavior: 'smooth' }); });
      if (next && thumbsWrap) next.addEventListener('click', function () { thumbsWrap.scrollBy({ left: 98, behavior: 'smooth' }); });

      /* ---- Single-item checkout ----
         Empty the cart, add the chosen package, go straight to checkout. Done in
         that order on submit rather than on page load: clearing on load races
         the click, and a clear that lands after the add sends the buyer to an
         empty checkout. If anything here fails we fall through to the native
         form post, which still reaches checkout via return_to. */
      var buyForm = root.querySelector('[data-gen-buy-form]');
      if (buyForm && window.fetch) {
        buyForm.addEventListener('submit', function (e) {
          if (buyForm.dataset.genSubmitting === '1') return;
          e.preventDefault();
          buyForm.dataset.genSubmitting = '1';
          var btn = buyForm.querySelector('.gen-pm__atc');
          if (btn) btn.disabled = true;

          var id = (root.querySelector('[data-gen-variant-id]') || {}).value;
          var qty = (root.querySelector('[data-gen-quantity]') || {}).value || 1;

          var post = function (url, body) {
            return fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body),
            });
          };

          post('/cart/clear.js', {})
            .then(function () { return post('/cart/add.js', { id: id, quantity: Number(qty) }); })
            .then(function (r) {
              if (!r.ok) throw new Error('add failed: ' + r.status);
              window.location.href = '/checkout';
            })
            .catch(function () {
              /* Let the browser do it the old way. */
              buyForm.dataset.genSubmitting = '0';
              if (btn) btn.disabled = false;
              buyForm.submit();
            });
        });
      }

      /* ---- Package selection ---- */
      var packages = root.querySelectorAll('.gen-pm__package');
      var idInput = root.querySelector('[data-gen-variant-id]');
      var qtyInput = root.querySelector('[data-gen-quantity]');
      var priceSets = root.querySelectorAll('.gen-pm__price-set');
      packages.forEach(function (pkg) {
        pkg.addEventListener('click', function () {
          packages.forEach(function (p) { p.classList.remove('is-selected'); });
          pkg.classList.add('is-selected');
          priceSets.forEach(function (ps) {
            ps.classList.toggle('is-active', ps.dataset.priceFor === pkg.dataset.packageId);
          });
          if (idInput && pkg.dataset.variantId) idInput.value = pkg.dataset.variantId;
          if (qtyInput && pkg.dataset.quantity) qtyInput.value = pkg.dataset.quantity;
        });
      });

      /* ---- Accordions ---- */
      root.querySelectorAll('.gen-pm__accordion').forEach(function (acc) {
        var head = acc.querySelector('.gen-pm__accordion-head');
        var body = acc.querySelector('.gen-pm__accordion-body');
        head.addEventListener('click', function () {
          var open = body.hasAttribute('hidden');
          if (open) {
            body.removeAttribute('hidden');
          } else {
            body.setAttribute('hidden', '');
          }
          acc.classList.toggle('is-open', open);
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gen-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gen-tl]').forEach(function (root) {
      var steps = root.querySelectorAll('[data-tl-step]');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!('IntersectionObserver' in window) || reduce) {
        steps.forEach(function (s) { s.classList.add('is-in'); });
        if (reduce) root.classList.add('js-reveal');
        return;
      }
      root.classList.add('js-reveal');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.35, rootMargin: '0px 0px -10% 0px' });
      steps.forEach(function (s) { io.observe(s); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gen-ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gen-ugc]').forEach(function (root) {
      var vp = root.querySelector('[data-ugc-viewport]');
      var prev = root.querySelector('[data-ugc-prev]');
      var next = root.querySelector('[data-ugc-next]');
      if (!vp) return;
      var index = 0;
      function step() {
        var track = vp.querySelector('.gen-ugc__track');
        var tile = vp.querySelector('.gen-ugc__tile');
        if (!tile) return vp.clientWidth;
        var gap = track ? (parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 12) : 12;
        return tile.offsetWidth + gap;
      }
      function total() { return vp.querySelectorAll('.gen-ugc__tile').length; }
      function visibleCount() { return Math.max(1, Math.round(vp.clientWidth / step())); }
      function maxIndex() { return Math.max(0, total() - visibleCount()); }
      function go(i) { index = i; vp.scrollTo({ left: Math.round(index * step()), behavior: 'smooth' }); }
      function advance() { go(index >= maxIndex() ? 0 : index + 1); }

      /* ---- autoplay ---- */
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var wanted = root.dataset.ugcAutoplay !== '0' && !reduce;
      var interval = parseInt(root.dataset.ugcInterval, 10) || 4000;
      var hovered = false, focused = false, touched = false, onScreen = true, timer = null;

      function running() { return wanted && !hovered && !focused && !touched && onScreen; }
      function restart() {
        if (timer) clearInterval(timer);
        timer = null;
        if (!wanted) return;
        /* One interval, gated by running(), rather than tearing the timer down
           and rebuilding it on every pointer event. */
        timer = setInterval(function () { if (running()) advance(); }, interval);
      }

      if (wanted) {
        var carousel = root.querySelector('.gen-ugc__carousel') || root;
        carousel.addEventListener('mouseenter', function () { hovered = true; });
        carousel.addEventListener('mouseleave', function () { hovered = false; });
        carousel.addEventListener('focusin', function () { focused = true; });
        carousel.addEventListener('focusout', function () { focused = false; });
        /* A swipe means the reader is browsing deliberately: hand it over. */
        vp.addEventListener('touchstart', function () { touched = true; }, { passive: true });

        if (window.IntersectionObserver) {
          new IntersectionObserver(function (entries) {
            onScreen = entries[0].isIntersecting;
          }, { threshold: 0.2 }).observe(root);
        }
        document.addEventListener('visibilitychange', function () {
          onScreen = !document.hidden && onScreen;
        });
        restart();
      }

      /* An arrow click resets the clock so the reader is not immediately
         yanked onward by a tick that was already almost due. */
      if (prev) prev.addEventListener('click', function () { go(index <= 0 ? maxIndex() : index - 1); restart(); });
      if (next) next.addEventListener('click', function () { advance(); restart(); });

      /* keep index in sync if the user swipes the strip manually */
      var t;
      vp.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { index = Math.round(vp.scrollLeft / step()); }, 120);
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
